import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22c8ede7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "openinghours__table" }
const _hoisted_2 = {
  class: "openinghours__illustrations",
  ref: "illustrations"
}
const _hoisted_3 = { class: "openinghours__illustration_container" }
const _hoisted_4 = { class: "openinghours__illustration_container" }
const _hoisted_5 = { class: "openinghours__illustration_container" }
const _hoisted_6 = { class: "openinghours__table_text" }
const _hoisted_7 = { class: "openinghours__timeperiod_title" }
const _hoisted_8 = { class: "openinghours__timeperiod_period" }
const _hoisted_9 = {
  key: 0,
  class: "openinghours__timeperiod_caption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_page_section = _resolveComponent("page-section")!

  return (_openBlock(), _createBlock(_component_page_section, {
    class: "openinghours section--no-top-margin",
    revealOnScroll: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Icon, {
              type: "sun",
              class: "openinghours__illustration"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              type: "sun",
              class: "openinghours__illustration"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Icon, {
              type: "sun",
              class: "openinghours__illustration"
            })
          ])
        ], 512),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeslots, (slot, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "openinghours__timeperiod",
              key: `timeslot-${index}`
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(slot.name), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(slot.time), 1),
              (slot.caption)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(slot.caption), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}